(function () {
    'use strict';

    angular
        .module('app')
        .directive('drvTextInput', function () {
            
            return  {
                templateUrl: 'app/fieldinput/text-input.tmpl.html',
                require: "ngModel",
                scope: {
                    value: '=ngModel',
                    field: '='
                },
                controller: ['$element', function ($element) {
                    var drvCtrl = this;
                    drvCtrl.showSuffix = showSuffix;
                    drvCtrl.calculateInputWidth = calculateInputWidth;

                    activate();

                    function activate() {
                    }

                    function calculateInputWidth() {
                        if ($element[0].firstElementChild.clientWidth === 0) {
                            return null;
                        }

                        var result = 30;
                        var elementSmallerThanLength = false;



                        if ((!angular.isUndefined(drvCtrl.field.Length) && drvCtrl.field.Length !== null) || (!angular.isUndefined(drvCtrl.value) && drvCtrl.value !== null && drvCtrl.value.length > 30)) {
                            var length;

                            if (!angular.isUndefined(drvCtrl.field.Length) && drvCtrl.field.Length !== null) {
                                length = drvCtrl.field.Length;
                            }
                            else {
                                length = drvCtrl.value.length;
                            }

                            var pixelNeeded = (length * 12) + 60;
                            if (pixelNeeded > $element[0].firstElementChild.clientWidth) {
                                elementSmallerThanLength = true;
                            }
                            else {
                                result = length + 5;
                            }
                        }

                        if (($element[0].firstElementChild.clientWidth < 380 && (angular.isUndefined(drvCtrl.field.Length) || drvCtrl.field.Length === null)) || elementSmallerThanLength) {
                            result = Math.floor($element[0].firstElementChild.clientWidth / 12) - 5;
                        }

                        return result * 0.7;
                    }

                    function showSuffix() {
                        return !_.isNil(drvCtrl.field) && !_.isNil(drvCtrl.field.Suffix) && drvCtrl.field.Suffix !== '';
                    }
                }],
                controllerAs: 'drvCtrl',
                bindToController: {
                    value: '=ngModel',
                    field: '='
                },
                link: function (scope, elem, attr) {
                    angular.element(window).on('resize', function () {
                        scope.$apply(function () {
                            scope.drvCtrl.calculateInputWidth();
                        });
                    });
                }
            };
        });
})();